import React = require("react");
import {connect} from "react-redux";
import {iState} from './store';
import {iConfig} from "./interfaces";
import * as actions from "./actions";
import {iSetMetric, iSetPeriod, iSetYear} from "./actions";
import * as cnst from './const';
import {iSetQuarter} from "./actions";
import {Legend} from "./Legend";


class _YearQuarterMetric extends React.Component<{
    conf: iConfig,
    year: number,
    quarter: number,
    period: string,
    metric: string,
    setYear: (y: number) => any,
    setQuarter: (q: number) => any,
    setPeriod: (p: string) => any,
    setMetric: (m: string) => any
}, {}> {

    render() {

        let yearLis = [];
        let periodLis = [];
        let quarterLis = [];
        let metricLis = [];

        for (let m of cnst.METRICS) {
            metricLis.push(<li key={`met-${m}`}>
                <label htmlFor={`met-${m}`}>{m}</label>
                <input
                    id={`met-${m}`}
                    type="radio"
                    value={m}
                    name="metric-select"
                    checked={m === this.props.metric}
                    onChange={(e) => {
                        this.props.setMetric(e.target.value);
                    }}
                />
            </li>);
        }

        for (let i = 0; i < cnst.TIME_PERIODS.length; i++) {
            let per = cnst.TIME_PERIODS[i];
            let perLab = cnst.TIME_PERIODS_LABEL[i];

            periodLis.push(<li key={`prd-${per}`}>
                <label htmlFor={`prd-${per}`}>{perLab}</label>
                <input
                    id={`prd-${per}`}
                    type="radio"
                    value={per}
                    name="period-select"
                    checked={per === this.props.period}
                    onChange={(e) => {
                        this.props.setPeriod(e.target.value);
                    }}
                />
            </li>);
        }

        for (let yr of this.props.conf.npmrdsYears) {
            let qus = this.props.conf.yearQuarter[yr.toFixed()];

            if (!qus) {
                continue;
            }

            yearLis.push(<li key={`yr-${yr}`}>
                <label htmlFor={`yr-${yr}`}>{yr}</label>
                <input
                    id={`yr-${yr}`}
                    type="radio"
                    value={yr}
                    name="year-select"
                    checked={yr === this.props.year}
                    onChange={(e) => {
                        let newYear = parseInt(e.target.value);
                        this.props.setYear(newYear);
                        let newYearQs = this.props.conf.yearQuarter[newYear.toFixed()];
                        this.props.setQuarter(newYearQs[newYearQs.length - 1]);
                    }}
                />
            </li>);


        }

        if (this.props.year) {
            let selectedQus = this.props.conf.yearQuarter[
                this.props.year.toFixed()
                ];

            for (let qtrNum of selectedQus) {

                let keyId = `qrtr-${qtrNum}-${this.props.year}`;
                let qtrString = cnst.QUARTER_ARR[qtrNum - 1];

                quarterLis.push(<li key={`qrtr-${qtrNum}-${this.props.year}`}>
                    <label htmlFor={keyId}>{qtrString}</label>
                    <input
                        id={keyId}
                        type="radio"
                        value={qtrNum}
                        name="quarter-select"
                        checked={qtrNum === this.props.quarter}
                        onChange={(e) => {
                            let newQuarter = parseInt(e.target.value);
                            this.props.setQuarter(newQuarter);
                        }}
                    />
                </li>)
            }
        }


        return <div style={{padding: '5px'}}>
            <h2>MAPSS Performance</h2>
            <h4>Metric</h4>
            <ul>
                {metricLis}
            </ul>
            <Legend/>
            <div style={{display: "flex"}}>
                <div style={{flex: '1'}}>
                    <h4>Time Period</h4>
                    <ul>
                        {periodLis}
                    </ul>
                </div>
                <div style={{flex: '1'}}>
                    <h4>Year</h4>
                    <ul className="year-select">
                        {yearLis}
                    </ul>
                </div>
            </div>
            <h4>Quarter</h4>
            <ul>
                {quarterLis}
            </ul>
        </div>

    }
}

export const YearQuarterMetric = connect(
    (s: iState) => {
        return {
            conf: s.config,
            year: s.year,
            quarter: s.quarter,
            period: s.period,
            metric: s.metric
        };
    },
    (dispatch) => {
        return {
            setYear: (y: number) => {
                dispatch({type: actions.SET_YEAR, year: y} as iSetYear);
            },
            setQuarter: (q: number) => {
                dispatch({type: actions.SET_QUARTER, quarter: q} as iSetQuarter);
            },
            setPeriod: (p: string) => {
                dispatch({type: actions.SET_PERIOD, period: p} as iSetPeriod);
            },
            setMetric: (m: string) => {
                dispatch({type: actions.SET_METRIC, metric: m} as iSetMetric);
            },
        };
    }
)(_YearQuarterMetric);